<template>
  <div class="time-scale-selector" :class="{ open }">
    <dropdown-select
      v-model="value"
      :options="values"
      :label-parser="labelParser"
      :multiple="false"
      @open="open = true"
      @close="open = false"
    />
  </div>
</template>

<script>
import DropdownSelect from './DropdownSelect.vue'

export default {
  components: { DropdownSelect },
  model: {
    prop: 'selection',
    event: 'update',
  },
  props: ['selection', 'values'],
  data() {
    return {
      open: false,
    }
  },
  computed: {
    value: {
      get() {
        return this.selection
      },
      set(val) {
        this.$emit('update', val)
      },
    },
  },
  methods: {
    labelParser(selection) {
      return this.values.find(d => d.id === selection[0]).label
    },
  },
}
</script>

<style lang="stylus">
.time-scale-selector
  &[data-align="top"] .dropdown-select
    transform: rotate(180deg)

    .dropdown-select__label
      transform: scale(-1, -1)
      margin-left: vw(20px)
      padding-right: vw(25px)
      margin-right: 0px

      &:after
        right: vw(-5px)

    .dropdown-option > div
      transform: scale(-1, -1)
      width: 100%

  &[data-align="bottom"] .dropdown-select
    .dropdown-select__label
      margin-right: vw(20px)
      margin-left: 0px

  .dropdown-select__label
    m-font-size(12, 16)

    .mobile &
      font-size: 0.7em
      line-height: 1.33

      .mobile &
        +m-breakpoint(landscape)
          right: 0

  .dropdown-select__options
    border-bottom-left-radius: 20px
    border-bottom-right-radius: 20px
</style>
